var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinimiseMap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 2.0083H1.5V4.4088H0V0.407959H3.75V2.0083ZM23.75 0.407959H20V2.0083H22.25V4.4088H23.75V0.407959ZM23.75 25.7466H20V24.1463H22.25V21.7458H23.75V25.7466ZM1.5 24.1463H3.75V25.7466H0V21.7458H1.5V24.1463ZM5.28027 11.6427H10.5303V6.04154H9.03027V8.9107L5.06064 4.67553L3.99991 5.80721L7.96954 10.0424H5.28027L5.28027 11.6427ZM10.5303 14.2775L5.28027 14.2775L5.28027 15.8778H7.96954L3.99991 20.113L5.06064 21.2446L9.03027 17.0095V19.8786H10.5303V14.2775ZM18.25 11.6427H13V6.04154H14.5V8.9107L18.4696 4.67553L19.5304 5.80721L15.5607 10.0424H18.25V11.6427ZM13 14.2775L18.25 14.2775V15.8778H15.5607L19.5304 20.113L18.4696 21.2446L14.5 17.0095V19.8786H13V14.2775Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimiseMap);
export default __webpack_public_path__ + "static/media/minimise-map.518b14b4785deeb3c9b059df9f23dbc0.svg";
export { ForwardRef as ReactComponent };